import { Box, Flex, Text, Link as RadixLink } from '@radix-ui/themes';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <Box as="footer" pt="6" px="4" style={{ backgroundColor: 'var(--gray-2)' }}>
            <Flex direction="column" align="center" gap="4" width="100%" maxWidth="1080px" mx="auto">
                <Flex gap="6" justify="center" wrap="wrap">
                    <Box>
                        <Text size="2" mb="2" weight="bold">Company</Text>
                        <Flex direction="column" gap="2">
                            <Link to="/" style={{ textDecoration: 'none', color: 'var(--gray-11)' }}>
                                <Text size="2">Home</Text>
                            </Link>
                            <Link to="/about" style={{ textDecoration: 'none', color: 'var(--gray-11)' }}>
                                <Text size="2">About</Text>
                            </Link>
                            {/* <Link to="/contact" style={{ textDecoration: 'none', color: 'var(--gray-11)' }}>
                                <Text size="2">Contact</Text>
                            </Link> */}
                        </Flex>
                    </Box>

                    <Box>
                        <Text size="2" mb="2" weight="bold">Legal</Text>
                        <Flex direction="column" gap="2">
                            <Link to="/legal/privacy" style={{ textDecoration: 'none', color: 'var(--gray-11)' }}>
                                <Text size="2">Privacy Policy</Text>
                            </Link>
                            <Link to="/legal/terms" style={{ textDecoration: 'none', color: 'var(--gray-11)' }}>
                                <Text size="2">Terms of Service</Text>
                            </Link>
                        </Flex>
                    </Box>

                    <Box>
                        <Text size="2" mb="2" weight="bold">Platform</Text>
                        <Flex direction="column" gap="2">
                            <Link to="/register" style={{ textDecoration: 'none', color: 'var(--gray-11)' }}>
                                <Text size="2">Get Started</Text>
                            </Link>
                            <Link to="/login" style={{ textDecoration: 'none', color: 'var(--gray-11)' }}>
                                <Text size="2">Login</Text>
                            </Link>
                        </Flex>
                    </Box>
                </Flex>

                <Box mt="4" style={{ borderTop: '1px solid var(--gray-5)', width: '100%' }} pt="4">
                    <Flex justify="center" align="center">
                        <Text size="1" color="gray">
                            {new Date().getFullYear()} Dext Technology. All rights reserved.
                        </Text>
                    </Flex>
                </Box>
            </Flex>
        </Box>
    );
};

export default Footer;
